const ru = {
  nav: {
    home: "Главная", how: "Как это работает", licensing: "Лицензирование", impact: "Влияние и CO₂",
    contact: "Контакты", cta: "Запросить лицензию", pseq2: "PSEQ2", menu: "Меню", close: "Закрыть", logout: "Выйти", oracle: "Оракул",
  },
  admin: {
    title: "Панель администратора",
    licenses: "Заявки на лицензии",
    contacts: "Сообщения",
    empty: "Пока пусто.",
    forbidden: "Доступ только для команды Dekrbat Pure.",
    statusT: "Статус",
    pending: "Ожидает",
    accepted: "Принята",
    rejected: "Отклонена",
    accept: "Принять",
    reject: "Отклонить",
    loginFirst: "Войдите с учётной записью администратора.",
    filterAll: "Все",
    reply: "Ответить",
    date: "Дата",
  },
  oracle: {
    overline: "Офлайн-оракул",
    title: "Оракул Dekrbat — прогноз и констатация в реальном времени",
    sub: "Установите приложение: погода каждой зоны загружается в фоне. Графики, констатации и PDF-отчёты работают офлайн.",
    install: "Установить приложение",
    installing: "Используйте меню браузера для установки",
    online: "Онлайн",
    offline: "Офлайн — данные из кэша",
    syncing: "Синхронизация зон",
    syncNow: "Синхронизировать",
    lastSync: "Последняя синхронизация",
    never: "никогда",
    defaultZone: "Креветочная зона",
    scenarioZone: "Ваш сценарий",
    constatTitle: "Констатация в реальном времени",
    cachedAt: "Данные от",
    verdicts: { validated: "Подтверждено", partial: "Частично", rejected: "Отклонено" },
    criteria: { temp: "Температура", sunshine: "Солнце", humidity: "Влажность", pressure: "Давление", co2: "CO₂" },
    predTitle: "Прогноз на 7 дней",
    weeklyPts: "PSEQ2 оценка на пруд / неделю",
    chartTemp: "Макс. темп.",
    chartSun: "Солнце",
    reportBtn: "PDF-отчёт зоны",
    noData: "Пока нет данных по зоне — синхронизируйтесь онлайн.",
    customZone: "Моя зона",
    addZoneTitle: "Добавить свою зону",
    addZoneHint: "Нажмите на карту, чтобы поставить метку, назовите зону и сохраните.",
    zoneNamePh: "Название зоны",
    saveZone: "Сохранить",
    loginToAdd: "Войдите, чтобы сохранять свои зоны, подключать датчики и получать оповещения по e-mail.",
    zoneSaved: "Зона сохранена",
    zoneDeleted: "Зона удалена",
    saveFailed: "Ошибка сохранения",
    deleteZone: "Удалить",
    alertsOn: "Оповещения по e-mail включены",
    alertsOff: "Оповещения по e-mail выключены",
    sensorConnect: "Подключить датчик",
    sensorKeyOnce: "API-ключ — скопируйте его сейчас, он больше не будет показан.",
    sensorLive: "Реальный датчик",
    sensorOffline: "Датчик офлайн",
    sensorCurl: "Пример отправки с вашего шлюза",
    thresholdsTitle: "Свои пороги",
    idealRange: "идеальный диапазон",
    sunMin: "мин (ч)",
    thresholdsSaved: "Пороги сохранены",
    sensorHistory: "История датчика",
    noSensorData: "Пока нет показаний датчика.",
    fieldMode: "Полевой режим",
    freshToday: "Данные за сегодня",
    freshCache: "Кэш от",
    tour: {
      replay: "Обучение",
      next: "Далее",
      skip: "Пропустить",
      done: "Готово",
      steps: [
        { t: "Добро пожаловать в Oracle", b: "60 секунд, чтобы освоить мониторинг ваших прудов. Поехали!" },
        { t: "Статус соединения", b: "Зелёный = онлайн, жёлтый = офлайн с кэшем. Oracle работает даже без сети." },
        { t: "Синхронизация", b: "Один клик загружает погоду на 7 дней вперёд для всех ваших зон." },
        { t: "Полевой режим", b: "Крупные кнопки и усиленный контраст: читается на ярком солнце у прудов." },
        { t: "Своя зона", b: "Нажмите на карту и назовите зону: она будет отслеживаться как остальные (нужен вход)." },
        { t: "Вердикт с первого взгляда", b: "Подтверждено, Частично или Отклонено: дневная сводка, с реальными датчиками, если они подключены." },
        { t: "Установите приложение", b: "Добавьте Oracle на телефон: открывается как приложение, даже офлайн." },
        { t: "Вот и всё!", b: "Повторите обучение в любой момент кнопкой «Обучение» наверху." },
      ],
    },
  },
  landing: {
    overline: "Рассекреченное досье",
    title: "Местный живой корм для личинок креветок вашего региона.",
    sub: "Полная система производства микроводорослей, соединяющая ремесленных производителей с личиночными хозяйствами: короткая цепочка, ноль импорта, доход остаётся в регионе.",
    points: ["Ремесленное производство живых микроводорослей", "Короткая цепочка производитель → хозяйство", "Доход остаётся в вашем регионе"],
    visitor: "Войти как гость",
    google: "Продолжить с Google",
    divider: "или по эл. почте",
    name: "Имя",
    email: "Эл. почта",
    password: "Пароль",
    loginBtn: "Войти",
    signupBtn: "Создать аккаунт",
    toSignup: "Нет аккаунта? Создать",
    toLogin: "Уже есть аккаунт? Войти",
    err: "Неверные данные или почта уже зарегистрирована",
  },
  hero: {
    overline: "Родом из Сальвадора · глобальный охват",
    lines: ["Местный живой корм", "для молоди креветок", "вашего региона."],
    sub: "Dekrbat Pure лицензирует полную систему производства микроводорослей, напрямую связывая ремесленных производителей с личиночными хозяйствами креветок — короткая цепочка поставок, снижающая зависимость от импортных кормов и превращающая CO₂ в углеродные баллы, подтверждённые датчиками.",
    ctaPrimary: "Запросить лицензию",
    ctaSecondary: "Как это работает",
    imageCaption: "Пруды культивирования микроводорослей",
    telemetryLabel: "Оракул декарбонизации",
    telemetryLive: "прямой сигнал",
    telemetryNote: "Концептуальная симуляция передачи",
    telemetryLines: [
      "датчик A-03 · растворённый CO₂ · показание подтверждено",
      "оракул · естественное поглощение подтверждено",
      "углеродный балл выпущен · партия #0182",
      "датчик B-11 · качество воды · параметры стабильны",
      "оракул · телеметрия прудов синхронизирована",
      "углеродный балл выпущен · партия #0183",
    ],
  },
  valprop: {
    overline: "Предложение",
    title: "Короткая цепочка заменяет импортную",
    imported: {
      title: "Импортное сырьё",
      points: [
        "Проходит тысячи километров до хозяйства",
        "Затраты зависят от валют и международной логистики",
        "Ограниченная прослеживаемость биологического происхождения",
        "Экономическая ценность покидает регион",
      ],
    },
    local: {
      title: "Локальная сеть Dekrbat Pure",
      points: [
        "Микроводоросли выращиваются в прудах внутри региона",
        "Прямая доставка от ремесленного производителя к хозяйству",
        "Датчики телеметрии в каждом пруду",
        "Устойчивая занятость, ценность остаётся в вашем регионе",
      ],
    },
  },
  bento: {
    overline: "Система",
    title: "Четыре элемента, одна экосистема",
    items: {
      ponds: { title: "Пруды культивирования", desc: "Инфраструктура производства микроводорослей для прибрежных и сельских условий." },
      coops: { title: "Сеть кооперативов", desc: "Организованные ремесленные производители напрямую снабжают личиночные лаборатории своего региона." },
      sensors: { title: "Встроенные датчики", desc: "Непрерывный мониторинг качества воды и растворённого CO₂ в каждом пруду." },
      oracle: { title: "Углеродный оракул", desc: "Подтверждённая телеметрия превращается в углеродные баллы в реальном времени, прослеживаемые по партиям." },
    },
  },
  marquee: [
    "Продовольственный суверенитет", "Нулевая зависимость от импорта", "Прослеживаемость датчиками",
    "Устойчивая местная занятость", "Углеродные баллы в реальном времени", "Короткая цепочка поставок",
  ],
  calc: {
    overline: "Концептуальная модель",
    title: "Рассчитайте свою сеть прудов",
    desc: "Посмотрите, как телеметрия системы масштабируется с площадью культивирования.",
    sliderLabel: "Гектары прудов",
    unit: "га",
    outputs: { volume: "Относительный индекс производства", datapoints: "Показаний датчиков в день", points: "Углеродных баллов в день" },
    disclaimer: "Смоделированные значения, только для иллюстрации. Не являются реальными данными о производительности.",
  },
    xr: {
      overline: "Пространственный режим",
      title: "Твоя ферма голограммой вокруг тебя",
      sub: "Очки XREAL, Beam Pro или обычный экран: симулятор PSEQ2 становится объёмной 3D-сценой — спутниковый глобус, пруды в объёме, живая погода.",
    },
  ctaSection: {
    title: "Готовы вырастить будущее креветок?",
    desc: "Присоединяйтесь к первой лицензированной сети микроводорослей для личиночного производства.",
    btn: "Запросить лицензию",
  },
  how: {
    hero: {
      overline: "Как это работает",
      title: "От пруда к личинке, без посредников",
      sub: "Экосистема из четырёх шагов, превращающая воду, свет и CO₂ в местный живой корм — с измерениями на каждом этапе.",
    },
    steps: [
      { k: "Шаг 01", title: "Строительство и инокуляция", desc: "Каждый лицензированный объект устанавливает пруды и получает стартовые штампы вместе с протоколом производства Dekrbat Pure." },
      { k: "Шаг 02", title: "Рост под контролем датчиков", desc: "Оптические зонды и датчики растворённого CO₂ фиксируют качество воды и биологическую активность в реальном времени, пруд за прудом." },
      { k: "Шаг 03", title: "Прямая местная дистрибуция", desc: "Урожай идёт от ремесленного производителя к хозяйству того же региона — короткая цепочка без импорта." },
      { k: "Шаг 04", title: "Валидация оракулом", desc: "Оракул декарбонизации подтверждает измеренное датчиками естественное поглощение CO₂ и выпускает прослеживаемые углеродные баллы." },
    ],
    sensor: {
      overline: "Технология",
      title: "Телеметрия, которая никогда не спит",
      desc: "Каждый лицензированный пруд оснащён комплектом датчиков, передающим непрерывные показания оракулу декарбонизации.",
      points: ["Оптические зонды качества воды", "Датчики растворённого CO₂", "Передача данных в реальном времени", "Прослеживаемость по прудам и партиям"],
    },
    galleryCaptions: ["Инспекция личинок креветок", "Образец культуры в лаборатории"],
  },
  licensing: {
    hero: {
      overline: "Лицензирование",
      title: "Лицензия для любого масштаба производства",
      sub: "Dekrbat Pure лицензирует свою полную систему производства микроводорослей для кооперативов и отдельных объектов в любой точке мира.",
    },
    coop: {
      badge: "Кооперативы",
      title: "Лицензия для кооператива",
      desc: "Региональная модель для кооперативов и ассоциаций производителей с несколькими фермами или личиночными лабораториями.",
      features: [
        "Покрытие нескольких ферм одной лицензией",
        "Комплекты датчиков для каждого пруда",
        "Протоколы производства и обучение команды",
        "Доступ кооператива к панели телеметрии оракула",
        "Связь с личиночными хозяйствами региона",
      ],
    },
    site: {
      badge: "Отдельные объекты",
      title: "Лицензия для объекта",
      desc: "Индивидуальное развёртывание для одной установки: лаборатория, ферма или пилотный пруд.",
      features: [
        "Лицензия на одну установку",
        "Комплект датчиков под размер объекта",
        "Помощь при запуске и первая инокуляция",
        "Собственная телеметрия и углеродные баллы объекта",
        "Путь роста к кооперативной модели",
      ],
    },
    selectBtn: "Запросить эту лицензию",
    form: {
      title: "Заявка на лицензию",
      desc: "Расскажите о своём производстве, и команда Dekrbat Pure рассмотрит вашу заявку.",
      name: "Полное имя", org: "Кооператив или компания", email: "Эл. почта", phone: "Телефон",
      department: "Страна / регион", type: "Тип лицензии", typeCoop: "Кооператив", typeSite: "Объект",
      ponds: "Количество прудов или гектаров", message: "Сообщение (необязательно)",
      submit: "Отправить заявку", sending: "Отправка…",
      success: "Заявка получена. Команда Dekrbat Pure рассмотрит её в ближайшее время.",
      error: "Не удалось отправить. Попробуйте снова.",
      selectPlaceholder: "Выберите вариант",
    },
  },
  impact: {
    hero: {
      overline: "Влияние и CO₂",
      title: "Каждый пруд измеряет то, что поглощает",
      sub: "Микроводоросли естественно поглощают CO₂ по мере роста. Dekrbat Pure измеряет это поглощение датчиками и подтверждает его оракулом декарбонизации, генерируя углеродные баллы в реальном времени.",
    },
    oracle: {
      overline: "Оракул",
      title: "От сигнала датчика к углеродному баллу",
      desc: "Архитектура измерений Dekrbat Pure превращает биологическую телеметрию в проверяемую запись, без опоры на внешние заявления.",
      flow: ["Пруды микроводорослей", "Датчики CO₂", "Оракул декарбонизации", "Углеродные баллы"],
      flowDescs: [
        "Естественное поглощение CO₂ во время роста",
        "Непрерывные показания растворённого CO₂",
        "Валидация телеметрии в реальном времени",
        "Запись, прослеживаемая по прудам и партиям",
      ],
    },
    telemetry: { title: "Живая телеметрия", note: "Концептуальная симуляция потока данных" },
    reel: {
      overline: "История углерода",
      title: "От пруда к углеродному баллу, в движении",
      slides: [
        { k: "01 · Пруды", title: "Живая культура", desc: "Пруды микроводорослей естественно поглощают CO₂, производя живой корм для хозяйств." },
        { k: "02 · Датчики", title: "Непрерывные измерения", desc: "Зонды растворённого CO₂ и качества воды фиксируют каждый пруд в реальном времени." },
        { k: "03 · Оракул", title: "Валидация", desc: "Оракул декарбонизации подтверждает телеметрию, превращая её в проверяемую запись." },
        { k: "04 · Баллы", title: "Углеродные баллы", desc: "Каждая валидация выпускает углеродные баллы, прослеживаемые по прудам и партиям." },
      ],
    },
    chain: {
      overline: "Цепочка ценности",
      title: "Влияние в четырёх измерениях",
      items: [
        { title: "Экология", desc: "Естественное извлечение CO₂, измеренное датчиками и подтверждённое оракулом, партия за партией." },
        { title: "Социум", desc: "Долгосрочная устойчивая занятость для ремесленных производителей и кооперативов." },
        { title: "Экономика", desc: "Устойчивость хозяйств за счёт снижения зависимости от импортного сырья." },
        { title: "Надёжность поставок", desc: "Новая местная цепочка ценности вокруг прудов культивирования микроводорослей." },
      ],
    },
  },
  contact: {
    hero: {
      overline: "Контакты",
      title: "Обсудим ваш проект",
      sub: "Напишите нам, и команда Dekrbat Pure ответит. Вы также можете просмотреть сохранённые заявки в системе.",
    },
    form: {
      name: "Полное имя", email: "Эл. почта", subject: "Тема", message: "Сообщение",
      submit: "Отправить сообщение", sending: "Отправка…",
      success: "Сообщение отправлено и сохранено.", error: "Не удалось отправить. Попробуйте снова.",
    },
    drawer: {
      btn: "Просмотреть заявки", title: "Сохранённые заявки", empty: "Пока нет сохранённых заявок.",
      licenseTag: "Лицензия", contactTag: "Контакт", close: "Закрыть", loading: "Загрузка…",
    },
  },
  intro: {
    dossier: "Досье · Глобально", skip: "Нажмите, чтобы пропустить",
    soundOn: "Звук включён — нажмите, чтобы выключить", soundOff: "Звук выключен",
  },
  story: {
    overline: "История",
    title: "Экономика солидарности, рождённая из воды",
    scenes: [
      { k: "Сцена 01", title: "Ценность уходит", desc: "Годами корм для личиночных хозяйств привозили импортным: каждая покупка уносила ресурсы из региона." },
      { k: "Сцена 02", title: "Производитель выращивает", desc: "Ремесленные производители поднимают пруды микроводорослей: вода, солнце и CO₂ становятся живым кормом." },
      { k: "Сцена 03", title: "Кооператив связывает", desc: "Урожай идёт напрямую к хозяйству региона. Без посредников, без импорта: короткая цепочка." },
      { k: "Сцена 04", title: "Ценность остаётся", desc: "Устойчивая местная занятость, доход кооператива и углеродные баллы, подтверждённые датчиками: экономика растёт дома." },
    ],
  },
  pseq2: {
    overline: "Предустановочная визуализация",
    title: "PSEQ2 — точка секвестрации 2-го поколения",
    sub: "Прежде чем устанавливать пруды микроводорослей, оцените потенциал декарбонизации любой точки планеты: реальный местный климат питает симуляцию, а каждый результат появляется в голографическом кубе.",
    config: {
      title: "Настройте проект",
      bassins: "Количество прудов",
      bassinsFree: "Или введите точное число",
      surfaceFixed: "Площадь пруда: 100 м² — разделён на 4 независимых модуля по 25 м² для ограничения перекрёстного заражения",
      totalSurface: "Общая площадь",
      sun: "Покрытие объекта",
      sunFull: "Открытое", sunMid: "Смешанное", sunLow: "Затенённое",
      searchPlaceholder: "Найти город или место…",
      share: "Поделиться симуляцией",
      shareCopied: "Ссылка скопирована",
    },
    location: {
      title: "Расположение проекта",
      hint: "Нажмите на карту или найдите место",
      loading: "Загрузка местного климата…",
      error: "Климат недоступен для этой точки",
      none: "Выберите точку на карте",
      satellite: "Спутник",
      mapLabel: "Карта",
      locate: "Моё местоположение",
    },
    tour: {
      replay: "Обучение",
      next: "Далее",
      skip: "Пропустить",
      done: "Готово",
      steps: [
        { t: "Добро пожаловать в симулятор PSEQ2", b: "Минута, чтобы оценить локальное производство живого корма. Поехали!" },
        { t: "Количество прудов", b: "Передвиньте ползунок: каждый пруд — независимая единица 100 м², ограничивающая перекрёстное заражение." },
        { t: "Солнечный режим", b: "Открытое небо, смешанный или тень: свет управляет ростом микроводорослей." },
        { t: "Место проекта", b: "Нажмите на карту или «Моё местоположение»: симулятор загрузит реальную погоду места." },
        { t: "Голографический куб", b: "Ваши результаты в 3D: очки PSEQ2, поглощённый CO₂, локальный корм и рабочие места. Вращайте пальцем." },
        { t: "PDF-отчёт", b: "Экспортируйте полный отчёт о сценарии — готов к отправке в ваш кооператив." },
        { t: "Поделиться симуляцией", b: "Один клик копирует ссылку со спутниковой карточкой для WhatsApp и соцсетей." },
        { t: "Готово!", b: "Повторите обучение в любой момент кнопкой «Обучение»." },
      ],
    },
    weather: { temp: "Температура", humidity: "Влажность", pressure: "Давление", sunshine: "Солнце в день", hours: "ч" },
    rating: {
      title: "Вердикт по размещению",
      basis: "Рассчитано по реальному местному климату: температура, солнце, влажность и давление",
      levels: ["Не рекомендуется", "Терпимо", "Нормально", "Хорошо", "Супер"],
    },
    cubes: {
      pseq2: { label: "Потенциальные PSEQ2", unit: "балл / год" },
      co2: { label: "Секвестрированный CO₂", unit: "т / год" },
      feed: { label: "Местный живой корм", unit: "индекс" },
      jobs: { label: "Местные рабочие места", unit: "позиции" },
    },
    preview: {
      title: "Предпросмотр отчёта",
      config: "Конфигурация",
      weather: "Местный климат",
      capacity: "Сводка мощности",
      contaminationTitle: "Сдерживание заражения",
      contaminationText: "Каждый пруд 100 м² разделён на 4 независимых модуля по 25 м²: при появлении очага изолируется и уходит на карантин только этот модуль — остальное производство продолжается.",
    },
    history: {
      title: "История сценариев",
      save: "Сохранить сценарий",
      saved: "Сценарий сохранён",
      error: "Не удалось сохранить сценарий",
      empty: "Пока нет сохранённых сценариев: настройте и сохраните первую симуляцию.",
      exportPdf: "Экспорт PDF",
      publish: "Опубликовать",
      unpublish: "Снять",
      sharedTag: "Публичный",
      tabAll: "Все",
      tabPublic: "Публичные",
      date: "Дата",
    },
    disclaimer: "Концептуальная модель предварительного просмотра: значения смоделированы на основе реального местного климата, не являются измерением или обязательством по производительности.",
    what: {
      overline: "Определение",
      title: "Что такое PSEQ2?",
      desc: "PSEQ2 — точка секвестрации второго поколения — единица, которую выпускает оракул декарбонизации Dekrbat Pure, когда телеметрия датчиков подтверждает естественное поглощение CO₂ микроводорослями.",
      cards: [
        { title: "Измерено", desc: "Зонды растворённого CO₂ и качества воды работают непрерывно в каждом пруду." },
        { title: "Подтверждено", desc: "Оракул проверяет телеметрию в реальном времени, пруд за прудом, партия за партией." },
        { title: "Выпущено", desc: "Каждая валидация создаёт прослеживаемый PSEQ2, видимый в ваших голографических кубах." },
      ],
    },
    cta: {
      title: "От симуляции к реальному пруду",
      desc: "Запросите лицензию и превратите эти голографические кубы в реальную телеметрию.",
      btn: "Запросить лицензию",
    },
    teaser: {
      overline: "Новинка",
      title: "Визуализируйте до установки",
      desc: "Симулятор PSEQ2 проецирует потенциал декарбонизации ваших будущих прудов в 3D-голографические кубы с реальным местным климатом.",
      btn: "Открыть симулятор",
    },
  },
  footer: {
    tagline: "Локальные системы культивирования микроводорослей для креветочных хозяйств — из Сальвадора в мир.",
    nav: "Навигация",
    location: "Сальвадор, Центральная Америка",
    rights: "Все права защищены.",
  },
};

const ar = {
  nav: {
    home: "الرئيسية", how: "كيف يعمل", licensing: "الترخيص", impact: "الأثر و CO₂",
    contact: "اتصل بنا", cta: "اطلب الترخيص", pseq2: "PSEQ2", menu: "القائمة", close: "إغلاق", logout: "خروج", oracle: "الأوراكل",
  },
  admin: {
    title: "لوحة الإدارة",
    licenses: "طلبات الترخيص",
    contacts: "رسائل الاتصال",
    empty: "لا شيء هنا بعد.",
    forbidden: "الوصول مقصور على فريق Dekrbat Pure.",
    statusT: "الحالة",
    pending: "قيد الانتظار",
    accepted: "مقبولة",
    rejected: "مرفوضة",
    accept: "قبول",
    reject: "رفض",
    loginFirst: "سجّل الدخول بحساب مسؤول.",
    filterAll: "الكل",
    reply: "رد",
    date: "التاريخ",
  },
  oracle: {
    overline: "أوراكل دون اتصال",
    title: "أوراكل Dekrbat — تنبؤ ومعاينة فورية",
    sub: "ثبّت التطبيق: تُحمَّل بيانات طقس كل منطقة في الخلفية. تعمل الرسوم والمعاينات وتقارير PDF دون اتصال.",
    install: "تثبيت التطبيق",
    installing: "استخدم قائمة المتصفح للتثبيت",
    online: "متصل",
    offline: "غير متصل — بيانات مخزّنة",
    syncing: "مزامنة المناطق",
    syncNow: "زامن الآن",
    lastSync: "آخر مزامنة",
    never: "أبدًا",
    defaultZone: "منطقة روبيان",
    scenarioZone: "سيناريوك",
    constatTitle: "معاينة مباشرة",
    cachedAt: "بيانات بتاريخ",
    verdicts: { validated: "مُعتمد", partial: "جزئي", rejected: "مرفوض" },
    criteria: { temp: "الحرارة", sunshine: "الشمس", humidity: "الرطوبة", pressure: "الضغط", co2: "CO₂" },
    predTitle: "تنبؤ 7 أيام",
    weeklyPts: "PSEQ2 تقديري لكل حوض / أسبوع",
    chartTemp: "أقصى حرارة",
    chartSun: "الشمس",
    reportBtn: "تقرير PDF للمنطقة",
    noData: "لا توجد بيانات لهذه المنطقة بعد — زامن وأنت متصل.",
    customZone: "منطقتي",
    addZoneTitle: "أضف منطقتك",
    addZoneHint: "انقر على الخريطة لوضع الدبوس، سمِّ منطقتك، ثم احفظ.",
    zoneNamePh: "اسم المنطقة",
    saveZone: "حفظ",
    loginToAdd: "سجّل الدخول لحفظ مناطقك وربط مستشعراتك واستلام تنبيهات البريد.",
    zoneSaved: "تم حفظ المنطقة",
    zoneDeleted: "تم حذف المنطقة",
    saveFailed: "فشل الحفظ",
    deleteZone: "حذف",
    alertsOn: "تنبيهات البريد مفعّلة",
    alertsOff: "تنبيهات البريد معطّلة",
    sensorConnect: "ربط مستشعر",
    sensorKeyOnce: "مفتاح API — انسخه الآن، لن يُعرض مرة أخرى.",
    sensorLive: "مستشعر حقيقي",
    sensorOffline: "المستشعر غير متصل",
    sensorCurl: "مثال إرسال من البوابة",
    thresholdsTitle: "عتبات مخصصة",
    idealRange: "النطاق المثالي",
    sunMin: "الحد الأدنى (س)",
    thresholdsSaved: "تم حفظ العتبات",
    sensorHistory: "سجل المستشعر",
    noSensorData: "لا توجد قراءات للمستشعر بعد.",
    fieldMode: "وضع الميدان",
    freshToday: "بيانات اليوم",
    freshCache: "ذاكرة",
    tour: {
      replay: "البرنامج التعليمي",
      next: "التالي",
      skip: "تخطٍّ",
      done: "تم",
      steps: [
        { t: "مرحبًا بك في أوراكل", b: "٦٠ ثانية لإتقان مراقبة أحواضك. هيّا!" },
        { t: "حالة الاتصال", b: "أخضر = متصل، كهرماني = دون اتصال مع بيانات مخزّنة. يعمل أوراكل حتى بلا شبكة." },
        { t: "المزامنة", b: "نقرة واحدة تنزّل طقس الأيام السبعة القادمة لكل مناطقك." },
        { t: "وضع الميدان", b: "أزرار كبيرة وتباين معزّز: مقروء تحت الشمس الساطعة عند الأحواض." },
        { t: "منطقتك الخاصة", b: "انقر على الخريطة وسمِّ منطقتك: ستُراقَب مثل الباقي (يتطلب تسجيل الدخول)." },
        { t: "الحكم بنظرة", b: "مُعتمد أو جزئي أو مرفوض: نشرة اليوم الجوية، مع مستشعراتك الحقيقية إن كانت موصولة." },
        { t: "ثبّت التطبيق", b: "أضف أوراكل إلى هاتفك: يفتح كتطبيق حتى دون شبكة." },
        { t: "انتهينا!", b: "أعد هذا البرنامج في أي وقت بزر البرنامج التعليمي في الأعلى." },
      ],
    },
  },
  landing: {
    overline: "ملف رُفعت عنه السرية",
    title: "علف حي محلي لصغار الروبيان في منطقتك.",
    sub: "نظام متكامل لإنتاج الطحالب الدقيقة يربط المنتجين الحرفيين بمفرخات الروبيان: سلسلة قصيرة، استغناء عن الاستيراد، ودخل يبقى في المنطقة.",
    points: ["إنتاج حرفي للطحالب الحية", "سلسلة قصيرة من المنتج إلى المفرخة", "دخل يبقى في منطقتك"],
    visitor: "الدخول كزائر",
    google: "المتابعة عبر Google",
    divider: "أو عبر بريدك",
    name: "الاسم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    loginBtn: "دخول",
    signupBtn: "إنشاء حساب",
    toSignup: "لا حساب؟ أنشئ واحدًا",
    toLogin: "لديك حساب؟ دخول",
    err: "بيانات غير صالحة أو البريد مسجل مسبقًا",
  },
  hero: {
    overline: "من السلفادور · انتشار عالمي",
    lines: ["علف حي محلي", "لصغار الروبيان", "من منطقتك."],
    sub: "تُرخّص Dekrbat Pure نظامًا متكاملًا لإنتاج الطحالب الدقيقة يربط المنتجين الحرفيين مباشرة بمفقسات الروبيان — سلسلة إمداد قصيرة تقلل الاعتماد على المدخلات المستوردة وتحوّل ثاني أكسيد الكربون إلى نقاط كربونية موثقة بأجهزة الاستشعار.",
    ctaPrimary: "اطلب الترخيص",
    ctaSecondary: "شاهد كيف يعمل",
    imageCaption: "أحواض استزراع الطحالب الدقيقة",
    telemetryLabel: "أوراكل إزالة الكربون",
    telemetryLive: "إشارة مباشرة",
    telemetryNote: "بث توضيحي محاكى",
    telemetryLines: [
      "المستشعر A-03 · CO₂ المذاب · قراءة موثقة",
      "الأوراكل · تمت المصادقة على الامتصاص الطبيعي",
      "نقطة كربونية صادرة · دفعة #0182",
      "المستشعر B-11 · جودة المياه · مؤشرات مستقرة",
      "الأوراكل · تمت مزامنة بيانات الأحواض",
      "نقطة كربونية صادرة · دفعة #0183",
    ],
  },
  valprop: {
    overline: "العرض",
    title: "سلسلة قصيرة تحل محل سلسلة مستوردة",
    imported: {
      title: "مدخل مستورد",
      points: [
        "يسافر آلاف الكيلومترات إلى المفرخة",
        "تكاليف معرضة للعملات واللوجستيات الدولية",
        "تتبع محدود للمنشأ البيولوجي",
        "قيمة اقتصادية تغادر المنطقة",
      ],
    },
    local: {
      title: "شبكة Dekrbat Pure المحلية",
      points: [
        "استزراع الطحالب الدقيقة في أحواض داخل المنطقة",
        "تسليم مباشر من المنتج الحرفي إلى المفرخة",
        "قياس عن بُعد بالمستشعرات في كل حوض",
        "وظائف مستدامة وقيمة تبقى في منطقتك",
      ],
    },
  },
  bento: {
    overline: "النظام",
    title: "أربع قطع، منظومة واحدة",
    items: {
      ponds: { title: "أحواض الاستزراع", desc: "بنية إنتاج للطحالب الدقيقة مصممة للظروف الساحلية والريفية." },
      coops: { title: "شبكة التعاونيات", desc: "منتجون حرفيون منظمون يزودون مختبرات اليرقات في منطقتهم مباشرة." },
      sensors: { title: "مستشعرات مدمجة", desc: "مراقبة مستمرة لجودة المياه وثاني أكسيد الكربون المذاب في كل حوض." },
      oracle: { title: "أوراكل الكربون", desc: "البيانات الموثقة تتحول إلى نقاط كربونية فورية قابلة للتتبع بالدفعة." },
    },
  },
  marquee: [
    "السيادة الغذائية", "صفر اعتماد على الاستيراد", "تتبع بالمستشعرات",
    "وظائف محلية مستدامة", "نقاط كربونية فورية", "سلسلة إمداد قصيرة",
  ],
  calc: {
    overline: "نموذج توضيحي",
    title: "حدّد حجم شبكة أحواضك",
    desc: "استكشف كيف تتوسع بيانات النظام مع مساحة الاستزراع.",
    sliderLabel: "هكتارات أحواض الاستزراع",
    unit: "هكتار",
    outputs: { volume: "مؤشر إنتاج نسبي", datapoints: "قراءات المستشعرات يوميًا", points: "نقاط كربونية صادرة يوميًا" },
    disclaimer: "أرقام محاكاة لأغراض توضيحية فقط. لا تمثل بيانات أداء حقيقية.",
  },
    xr: {
      overline: "الوضع المكاني",
      title: "مزرعتك كهولوغرام من حولك",
      sub: "نظارات XREAL أو Beam Pro أو شاشة عادية: يتحول محاكي PSEQ2 إلى مجسّم ثلاثي الأبعاد — كوكب بالأقمار الصناعية وأحواض حجمية وطقس حي.",
    },
  ctaSection: {
    title: "هل أنت مستعد لزراعة مستقبل الروبيان؟",
    desc: "انضم إلى أول شبكة مرخّصة للطحالب الدقيقة لتفقيص الروبيان.",
    btn: "اطلب الترخيص",
  },
  how: {
    hero: {
      overline: "كيف يعمل",
      title: "من الحوض إلى اليرقة، بلا وسطاء",
      sub: "منظومة من أربع خطوات تحوّل الماء والضوء وثاني أكسيد الكربون إلى علف حي محلي — مقاسة في كل مرحلة.",
    },
    steps: [
      { k: "الخطوة 01", title: "البناء والتلقيح", desc: "كل موقع مرخّص يُنشئ أحواض الاستزراع ويستلم السلالات الأولى مع بروتوكول إنتاج Dekrbat Pure." },
      { k: "الخطوة 02", title: "نمو مراقَب بالمستشعرات", desc: "مجسات بصرية ومجسات CO₂ المذاب تسجل جودة المياه والنشاط الحيوي لحظيًا، حوضًا بحوض." },
      { k: "الخطوة 03", title: "توزيع محلي مباشر", desc: "ينتقل المحصول من المنتج الحرفي إلى مفرخة المنطقة نفسها — سلسلة قصيرة بلا استيراد." },
      { k: "الخطوة 04", title: "مصادقة الأوراكل", desc: "يصادق أوراكل إزالة الكربون على الامتصاص الطبيعي المقاس بالمستشعرات ويُصدر نقاطًا كربونية قابلة للتتبع." },
    ],
    sensor: {
      overline: "التقنية",
      title: "قياس عن بُعد لا ينام",
      desc: "كل حوض مرخّص يحمل عدّة مستشعرات تبث قراءات مستمرة إلى أوراكل إزالة الكربون.",
      points: ["مجسات بصرية لجودة المياه", "مستشعرات CO₂ المذاب", "نقل البيانات لحظيًا", "تتبع حسب الحوض والدفعة"],
    },
    galleryCaptions: ["فحص يرقات الروبيان", "عينة استزراع في المختبر"],
  },
  licensing: {
    hero: {
      overline: "الترخيص",
      title: "ترخيص لكل حجم إنتاج",
      sub: "تُرخّص Dekrbat Pure نظامها المتكامل لإنتاج الطحالب الدقيقة للتعاونيات والمواقع الفردية في أي منطقة من العالم.",
    },
    coop: {
      badge: "التعاونيات",
      title: "ترخيص التعاونية",
      desc: "نموذج إقليمي للتعاونيات وجمعيات المنتجين التي تدير مزارع أو مختبرات يرقات متعددة.",
      features: [
        "تغطية عدة مزارع بترخيص واحد",
        "عدد مستشعرات مخصصة لكل حوض",
        "بروتوكولات إنتاج وتدريب الفريق",
        "وصول التعاونية إلى لوحة بيانات الأوراكل",
        "ربط مع مفقسات المنطقة",
      ],
    },
    site: {
      badge: "المواقع الفردية",
      title: "ترخيص الموقع",
      desc: "نشر مخصص لمنشأة واحدة: مختبر يرقات أو مزرعة أو حوض تجريبي.",
      features: [
        "ترخيص مخصص لمنشأة واحدة",
        "عدّة مستشعرات بحجم الموقع",
        "تشغيل بمساعدة وتلقيح أولي",
        "بيانات ونقاط كربونية خاصة بالموقع",
        "مسار نمو نحو النموذج التعاوني",
      ],
    },
    selectBtn: "اطلب هذا الترخيص",
    form: {
      title: "طلب ترخيص",
      desc: "أخبرنا عن عملك وسيراجع فريق Dekrbat Pure طلبك.",
      name: "الاسم الكامل", org: "التعاونية أو الشركة", email: "البريد الإلكتروني", phone: "الهاتف",
      department: "البلد / المنطقة", type: "نوع الترخيص", typeCoop: "تعاونية", typeSite: "موقع",
      ponds: "عدد الأحواض أو الهكتارات", message: "رسالة (اختياري)",
      submit: "إرسال الطلب", sending: "جارٍ الإرسال…",
      success: "تم استلام الطلب. سيراجعه فريق Dekrbat Pure قريبًا.",
      error: "تعذر الإرسال. حاول مرة أخرى.",
      selectPlaceholder: "اختر خيارًا",
    },
  },
  impact: {
    hero: {
      overline: "الأثر و CO₂",
      title: "كل حوض يقيس ما يمتصه",
      sub: "تلتقط الطحالب الدقيقة ثاني أكسيد الكربون طبيعيًا أثناء نموها. تقيس Dekrbat Pure هذا الامتصاص بالمستشعرات وتصادق عليه عبر أوراكل إزالة الكربون، مولّدة نقاطًا كربونية فورية.",
    },
    oracle: {
      overline: "الأوراكل",
      title: "من إشارة المستشعر إلى النقطة الكربونية",
      desc: "تحوّل بنية قياس Dekrbat Pure البيانات الحيوية إلى سجل قابل للتحقق، دون الاعتماد على ادعاءات خارجية.",
      flow: ["أحواض الطحالب الدقيقة", "مستشعرات CO₂", "أوراكل إزالة الكربون", "النقاط الكربونية"],
      flowDescs: [
        "امتصاص طبيعي لثاني أكسيد الكربون أثناء النمو",
        "قراءات مستمرة للـ CO₂ المذاب",
        "مصادقة البيانات لحظيًا",
        "سجل قابل للتتبع حسب الحوض والدفعة",
      ],
    },
    telemetry: { title: "بيانات مباشرة", note: "محاكاة توضيحية لتدفق البيانات" },
    reel: {
      overline: "قصة الكربون",
      title: "من الحوض إلى النقطة الكربونية، متحركة",
      slides: [
        { k: "01 · الأحواض", title: "استزراع حي", desc: "أحواض الطحالب الدقيقة تلتقط CO₂ طبيعيًا بينما تنتج علفًا حيًا للمفقسات." },
        { k: "02 · المستشعرات", title: "قياس مستمر", desc: "مجسات CO₂ المذاب وجودة المياه تسجل كل حوض لحظيًا." },
        { k: "03 · الأوراكل", title: "المصادقة", desc: "يصادق أوراكل إزالة الكربون على البيانات ويحولها إلى سجل موثق." },
        { k: "04 · النقاط", title: "النقاط الكربونية", desc: "كل مصادقة تصدر نقاطًا كربونية قابلة للتتبع حسب الحوض والدفعة." },
      ],
    },
    chain: {
      overline: "سلسلة القيمة",
      title: "الأثر في أربعة أبعاد",
      items: [
        { title: "بيئي", desc: "استخراج طبيعي لثاني أكسيد الكربون مقاس بالمستشعرات ومصادق عليه من الأوراكل، دفعة بدفعة." },
        { title: "اجتماعي", desc: "توظيف محلي مستدام طويل الأمد للمنتجين الحرفيين والتعاونيات." },
        { title: "اقتصادي", desc: "مرونة للمفقسات عبر تقليل التعرض للمدخلات المستوردة." },
        { title: "أمن الإمداد", desc: "سلسلة قيمة محلية جديدة تتمحور حول أحواض الطحالب الدقيقة." },
      ],
    },
  },
  contact: {
    hero: {
      overline: "اتصل بنا",
      title: "لنتحدث عن مشروعك",
      sub: "اكتب لنا وسيرد فريق Dekrbat Pure عليك. يمكنك أيضًا مراجعة الطلبات المحفوظة في النظام.",
    },
    form: {
      name: "الاسم الكامل", email: "البريد الإلكتروني", subject: "الموضوع", message: "الرسالة",
      submit: "إرسال الرسالة", sending: "جارٍ الإرسال…",
      success: "تم إرسال الرسالة وحفظها.", error: "تعذر الإرسال. حاول مرة أخرى.",
    },
    drawer: {
      btn: "عرض الطلبات المحفوظة", title: "الطلبات المحفوظة", empty: "لا توجد طلبات محفوظة بعد.",
      licenseTag: "ترخيص", contactTag: "اتصال", close: "إغلاق", loading: "جارٍ التحميل…",
    },
  },
  intro: {
    dossier: "ملف · عالمي", skip: "انقر للتخطي",
    soundOn: "الصوت مفعّل — انقر للكتم", soundOff: "الصوت مكتوم",
  },
  story: {
    overline: "القصة",
    title: "اقتصاد تضامني يولد من الماء",
    scenes: [
      { k: "المشهد 01", title: "قيمة تغادر", desc: "لسنوات، وصل علف المفقسات مستوردًا: كل عملية شراء كانت ترسل الموارد خارج المنطقة." },
      { k: "المشهد 02", title: "المنتج يزرع", desc: "المنتجون الحرفيون ينشئون أحواض الطحالب الدقيقة: الماء والشمس و CO₂ يصبحون علفًا حيًا." },
      { k: "المشهد 03", title: "التعاونية تربط", desc: "ينتقل المحصول مباشرة إلى مفرخة المنطقة. بلا وسطاء وبلا استيراد: سلسلة قصيرة." },
      { k: "المشهد 04", title: "القيمة تبقى", desc: "وظائف محلية مستدامة ودخل للتعاونية ونقاط كربونية موثقة بالمستشعرات: الاقتصاد ينمو في الداخل." },
    ],
  },
  pseq2: {
    overline: "تصور ما قبل التركيب",
    title: "PSEQ2 — نقطة العزل من الجيل الثاني",
    sub: "قبل تركيب أحواض الطحالب الدقيقة، تصوّر إمكانات إزالة الكربون لأي نقطة على الكوكب: المناخ المحلي الحقيقي يغذي المحاكاة وكل نتيجة تظهر داخل مكعب هولوغرافي.",
    config: {
      title: "قم بإعداد مشروعك",
      bassins: "عدد الأحواض",
      bassinsFree: "أو اكتب العدد بدقة",
      surfaceFixed: "مساحة الحوض: 100 م² — مقسّم إلى 4 وحدات مستقلة بمساحة 25 م² للحد من التلوث المتبادل",
      totalSurface: "المساحة الإجمالية",
      sun: "تغطية الموقع",
      sunFull: "مكشوفة", sunMid: "مختلطة", sunLow: "مظللة",
      searchPlaceholder: "ابحث عن مدينة أو مكان…",
      share: "مشاركة المحاكاة",
      shareCopied: "تم نسخ الرابط",
    },
    location: {
      title: "موقع المشروع",
      hint: "انقر على الخريطة أو ابحث عن مكان",
      loading: "جارٍ تحميل المناخ المحلي…",
      error: "المناخ غير متاح عند هذه النقطة",
      none: "اختر نقطة على الخريطة",
      satellite: "قمر صناعي",
      mapLabel: "خريطة",
      locate: "موقعي",
    },
    tour: {
      replay: "البرنامج التعليمي",
      next: "التالي",
      skip: "تخطٍّ",
      done: "تم",
      steps: [
        { t: "مرحبًا بك في محاكي PSEQ2", b: "دقيقة واحدة لتقدير إنتاجك المحلي من الغذاء الحي. هيّا!" },
        { t: "عدد الأحواض", b: "اسحب المنزلق: كل حوض وحدة مستقلة بمساحة 100 م² تحدّ من التلوث المتبادل." },
        { t: "النظام الشمسي", b: "سماء مفتوحة أو مختلط أو مظلّل: الضوء يقود نمو الطحالب الدقيقة." },
        { t: "موقع المشروع", b: "انقر على الخريطة أو استخدم «موقعي»: يحمّل المحاكي الطقس الحقيقي للمكان." },
        { t: "المكعب الهولوغرافي", b: "نتائجك ثلاثية الأبعاد: نقاط PSEQ2 وCO₂ الممتص والغذاء المحلي والوظائف. أدره بإصبعك." },
        { t: "تقرير PDF", b: "صدّر تقريرًا كاملًا عن سيناريوهك، جاهزًا للمشاركة مع تعاونيتك." },
        { t: "مشاركة المحاكاة", b: "نقرة واحدة تنسخ رابطًا ببطاقة قمر صناعي للمعاينة في واتساب والشبكات." },
        { t: "تمّ!", b: "أعد هذا البرنامج في أي وقت بزر البرنامج التعليمي." },
      ],
    },
    weather: { temp: "الحرارة", humidity: "الرطوبة", pressure: "الضغط", sunshine: "الشمس يوميًا", hours: "س" },
    rating: {
      title: "حكم التركيب",
      basis: "محسوب من المناخ المحلي الحقيقي: الحرارة والشمس والرطوبة والضغط",
      levels: ["غير موصى به", "مقبول", "جيد", "جيد جدًا", "ممتاز"],
    },
    cubes: {
      pseq2: { label: "PSEQ2 محتملة", unit: "نقطة / سنة" },
      co2: { label: "CO₂ معزول", unit: "طن / سنة" },
      feed: { label: "علف حي محلي", unit: "مؤشر" },
      jobs: { label: "وظائف محلية", unit: "وظائف" },
    },
    preview: {
      title: "معاينة التقرير",
      config: "الإعدادات",
      weather: "المناخ المحلي",
      capacity: "ملخص السعة",
      contaminationTitle: "احتواء التلوث",
      contaminationText: "كل حوض بمساحة 100 م² مقسّم إلى 4 وحدات مستقلة بمساحة 25 م²: عند ظهور بؤرة تلوث تُعزل تلك الوحدة فقط وتدخل الحجر الصحي — ويستمر باقي الإنتاج.",
    },
    history: {
      title: "سجل السيناريوهات",
      save: "احفظ السيناريو",
      saved: "تم حفظ السيناريو",
      error: "تعذر حفظ السيناريو",
      empty: "لا توجد سيناريوهات محفوظة بعد: اضبط واحفظ أول محاكاة.",
      exportPdf: "تصدير PDF",
      publish: "انشر",
      unpublish: "إلغاء النشر",
      sharedTag: "عام",
      tabAll: "الكل",
      tabPublic: "العامة",
      date: "التاريخ",
    },
    disclaimer: "نموذج معاينة توضيحي: قيم محاكاة من المناخ المحلي الحقيقي، ليست قياسًا ولا التزامًا بالأداء.",
    what: {
      overline: "التعريف",
      title: "ما هو PSEQ2؟",
      desc: "PSEQ2 — نقطة العزل من الجيل الثاني — هي الوحدة التي يصدرها أوراكل إزالة الكربون من Dekrbat Pure عندما تصادق بيانات المستشعرات على التقاط طبيعي لثاني أكسيد الكربون بواسطة الطحالب الدقيقة.",
      cards: [
        { title: "مقاس", desc: "مجسات CO₂ المذاب وجودة المياه تعمل باستمرار في كل حوض." },
        { title: "مصادق عليه", desc: "يتحقق الأوراكل من البيانات لحظيًا، حوضًا بحوض ودفعة بدفعة." },
        { title: "صادر", desc: "كل مصادقة تولّد PSEQ2 قابلًا للتتبع، مرئيًا في مكعباتك الهولوغرافية." },
      ],
    },
    cta: {
      title: "انتقل من المحاكاة إلى الحوض الحقيقي",
      desc: "اطلب ترخيصك وحوّل هذه المكعبات الهولوغرافية إلى بيانات حقيقية.",
      btn: "اطلب الترخيص",
    },
    teaser: {
      overline: "جديد",
      title: "تصوّر قبل التركيب",
      desc: "يعرض محاكي PSEQ2 إمكانات إزالة الكربون لأحواضك المستقبلية في مكعبات هولوغرافية ثلاثية الأبعاد، مدعومة بالمناخ المحلي الحقيقي.",
      btn: "افتح المحاكي",
    },
  },
  footer: {
    tagline: "أنظمة محلية لاستزراع الطحالب الدقيقة لمفقسات الروبيان، من السلفادور إلى العالم.",
    nav: "التنقل",
    location: "السلفادور، أمريكا الوسطى",
    rights: "جميع الحقوق محفوظة.",
  },
};

const zh = {
  nav: {
    home: "首页", how: "运作方式", licensing: "许可授权", impact: "影响与 CO₂",
    contact: "联系我们", cta: "申请许可", pseq2: "PSEQ2", menu: "菜单", close: "关闭", logout: "退出", oracle: "神谕",
  },
  admin: {
    title: "管理面板",
    licenses: "许可申请",
    contacts: "联系消息",
    empty: "暂无内容。",
    forbidden: "仅限 Dekrbat Pure 团队访问。",
    statusT: "状态",
    pending: "待处理",
    accepted: "已接受",
    rejected: "已拒绝",
    accept: "接受",
    reject: "拒绝",
    loginFirst: "请使用管理员账户登录。",
    filterAll: "全部",
    reply: "回复",
    date: "日期",
  },
  oracle: {
    overline: "离线神谕",
    title: "Dekrbat 神谕 — 预测与实时观测",
    sub: "安装应用：每个区域的天气数据将在后台自动下载。图表、观测和 PDF 报告均可离线使用。",
    install: "安装应用",
    installing: "请使用浏览器菜单安装",
    online: "在线",
    offline: "离线 — 缓存数据",
    syncing: "正在同步区域",
    syncNow: "立即同步",
    lastSync: "上次同步",
    never: "从未",
    defaultZone: "虾类区域",
    scenarioZone: "您的情景",
    constatTitle: "实时观测",
    cachedAt: "数据时间",
    verdicts: { validated: "已验证", partial: "部分", rejected: "未通过" },
    criteria: { temp: "温度", sunshine: "日照", humidity: "湿度", pressure: "气压", co2: "CO₂" },
    predTitle: "7 天预测",
    weeklyPts: "每池每周预估 PSEQ2",
    chartTemp: "最高温",
    chartSun: "日照",
    reportBtn: "区域 PDF 报告",
    noData: "该区域暂无数据 — 请在线同步。",
    customZone: "我的区域",
    addZoneTitle: "添加你的区域",
    addZoneHint: "点击地图放置标记，命名区域并保存。",
    zoneNamePh: "区域名称",
    saveZone: "保存",
    loginToAdd: "登录后可保存自己的区域、连接传感器并接收邮件警报。",
    zoneSaved: "区域已保存",
    zoneDeleted: "区域已删除",
    saveFailed: "保存失败",
    deleteZone: "删除",
    alertsOn: "邮件提醒已开启",
    alertsOff: "邮件提醒已关闭",
    sensorConnect: "连接传感器",
    sensorKeyOnce: "API 密钥——请立即复制，之后不再显示。",
    sensorLive: "真实传感器",
    sensorOffline: "传感器离线",
    sensorCurl: "网关推送示例",
    thresholdsTitle: "自定义阈值",
    idealRange: "理想范围",
    sunMin: "最少 (小时)",
    thresholdsSaved: "阈值已保存",
    sensorHistory: "传感器历史",
    noSensorData: "暂无传感器读数。",
    fieldMode: "户外模式",
    freshToday: "今日数据",
    freshCache: "缓存自",
    tour: {
      replay: "教程",
      next: "下一步",
      skip: "跳过",
      done: "完成",
      steps: [
        { t: "欢迎使用 Oracle", b: "60 秒掌握你的池塘监测。开始吧！" },
        { t: "连接状态", b: "绿色 = 在线，琥珀色 = 离线使用缓存数据。即使没有网络 Oracle 也能工作。" },
        { t: "同步", b: "一键下载所有区域未来 7 天的天气。" },
        { t: "户外模式", b: "大按钮、强对比：在池塘边强光下也清晰可读。" },
        { t: "你自己的区域", b: "点击地图并命名区域：它会像其他区域一样被监测（需登录）。" },
        { t: "一眼看懂判定", b: "通过、部分或拒绝：今日天气评估，连接传感器后使用真实数据。" },
        { t: "安装应用", b: "把 Oracle 添加到手机：像应用一样打开，离线也能用。" },
        { t: "完成了！", b: "随时点击顶部的教程按钮重新观看。" },
      ],
    },
  },
  landing: {
    overline: "解密档案",
    title: "来自您所在地区的虾苗本地活体饵料。",
    sub: "完整的微藻生产系统连接手工生产者与虾苗场：短链供应、零进口依赖、收入留在本地。",
    points: ["手工活体微藻生产", "生产者到育苗场的短链", "收入留在您的地区"],
    visitor: "以访客身份进入",
    google: "使用 Google 继续",
    divider: "或使用邮箱",
    name: "姓名",
    email: "邮箱",
    password: "密码",
    loginBtn: "登录",
    signupBtn: "创建账户",
    toSignup: "没有账户？创建一个",
    toLogin: "已有账户？登录",
    err: "凭证无效或邮箱已注册",
  },
  hero: {
    overline: "源自萨尔瓦多 · 面向全球",
    lines: ["本地活体饵料", "助力幼虾成长", "就在您的地区。"],
    sub: "Dekrbat Pure 授权完整的微藻生产系统，将手工养殖者直接与虾苗孵化场连接起来——短供应链减少对进口饲料的依赖，并将二氧化碳转化为由传感器验证的碳积分。",
    ctaPrimary: "申请许可",
    ctaSecondary: "了解运作方式",
    imageCaption: "微藻养殖池",
    telemetryLabel: "脱碳预言机",
    telemetryLive: "实时信号",
    telemetryNote: "概念模拟数据流",
    telemetryLines: [
      "传感器 A-03 · 溶解 CO₂ · 读数已验证",
      "预言机 · 自然吸收已确认",
      "碳积分已发放 · 批次 #0182",
      "传感器 B-11 · 水质 · 参数稳定",
      "预言机 · 养殖池遥测已同步",
      "碳积分已发放 · 批次 #0183",
    ],
  },
  valprop: {
    overline: "核心价值",
    title: "短链供应链取代进口链条",
    imported: {
      title: "进口饲料",
      points: [
        "运输数千公里才能到达孵化场",
        "成本受汇率和国际物流影响",
        "生物来源可追溯性有限",
        "经济价值流出本地区",
      ],
    },
    local: {
      title: "Dekrbat Pure 本地网络",
      points: [
        "微藻在本地区的养殖池中培育",
        "从手工生产者直接送达孵化场",
        "每个养殖池配备传感器遥测",
        "可持续就业，价值留在您的地区",
      ],
    },
  },
  bento: {
    overline: "系统构成",
    title: "四个部分，一个生态系统",
    items: {
      ponds: { title: "养殖池", desc: "为沿海和农村条件设计的微藻生产基础设施。" },
      coops: { title: "合作社网络", desc: "有组织的手工生产者直接供应本地区的虾苗实验室。" },
      sensors: { title: "在线传感器", desc: "对每个养殖池的水质和溶解 CO₂ 进行持续监测。" },
      oracle: { title: "碳预言机", desc: "经验证的遥测数据转化为实时碳积分，可按批次追溯。" },
    },
  },
  marquee: [
    "粮食主权", "零进口依赖", "传感器可追溯", "本地可持续就业", "实时碳积分", "短供应链",
  ],
  calc: {
    overline: "概念模型",
    title: "规划您的养殖池网络",
    desc: "探索系统遥测如何随养殖面积扩展。",
    sliderLabel: "养殖池公顷数",
    unit: "公顷",
    outputs: { volume: "相对生产指数", datapoints: "每日传感器读数", points: "每日碳积分发放" },
    disclaimer: "模拟数据仅供参考，不代表真实性能数据。",
  },
    xr: {
      overline: "空间模式",
      title: "你的养殖场化身全息影像，环绕身边",
      sub: "XREAL 眼镜、Beam Pro 或普通屏幕：PSEQ2 模拟器变成空间 3D 模型——卫星地球、立体池塘、实时天气。",
    },
  ctaSection: {
    title: "准备好培育虾业的未来了吗？",
    desc: "加入首个面向虾苗培育的许可微藻网络。",
    btn: "申请许可",
  },
  how: {
    hero: {
      overline: "运作方式",
      title: "从养殖池到虾苗，没有中间商",
      sub: "四步生态系统，将水、阳光和 CO₂ 转化为本地活体饵料——每一步都有测量。",
    },
    steps: [
      { k: "步骤 01", title: "建设与接种", desc: "每个许可场地安装养殖池，并接收初始藻种和 Dekrbat Pure 生产协议。" },
      { k: "步骤 02", title: "传感器监测生长", desc: "光学探头和溶解 CO₂ 传感器实时记录水质和生物活性，逐池监测。" },
      { k: "步骤 03", title: "本地直接配送", desc: "收获物从手工生产者直达同地区的孵化场——短链，无进口。" },
      { k: "步骤 04", title: "预言机验证", desc: "脱碳预言机验证传感器测得的 CO₂ 自然吸收，并发放可追溯的碳积分。" },
    ],
    sensor: {
      overline: "技术",
      title: "永不眠的遥测",
      desc: "每个许可养殖池配备传感器套件，向脱碳预言机持续传输读数。",
      points: ["光学水质探头", "溶解 CO₂ 传感器", "实时数据传输", "按池和批次追溯"],
    },
    galleryCaptions: ["虾苗检查", "实验室培养样本"],
  },
  licensing: {
    hero: {
      overline: "许可授权",
      title: "适合每种生产规模的许可",
      sub: "Dekrbat Pure 向世界任何地区的合作社和独立场地授权其完整的微藻生产系统。",
    },
    coop: {
      badge: "合作社",
      title: "合作社许可",
      desc: "面向拥有多个养殖场或虾苗实验室的合作社和生产者协会的区域模式。",
      features: [
        "单一许可覆盖多个养殖场",
        "按池分配传感器套件",
        "生产协议与团队培训",
        "合作社访问预言机遥测面板",
        "与本地区孵化场对接",
      ],
    },
    site: {
      badge: "独立场地",
      title: "场地许可",
      desc: "为单一设施量身定制：虾苗实验室、养殖场或试点池。",
      features: [
        "专属单一设施的许可",
        "按场地规模配置传感器套件",
        "协助调试与首次接种",
        "场地专属遥测与碳积分",
        "通往合作社模式的成长路径",
      ],
    },
    selectBtn: "申请此许可",
    form: {
      title: "许可申请",
      desc: "告诉我们您的运营情况，Dekrbat Pure 团队将审核您的申请。",
      name: "姓名", org: "合作社或公司", email: "电子邮箱", phone: "电话",
      department: "国家 / 地区", type: "许可类型", typeCoop: "合作社", typeSite: "场地",
      ponds: "养殖池数量或公顷数", message: "留言（可选）",
      submit: "提交申请", sending: "提交中…",
      success: "申请已收到。Dekrbat Pure 团队将尽快审核。",
      error: "发送失败，请重试。",
      selectPlaceholder: "请选择",
    },
  },
  impact: {
    hero: {
      overline: "影响与 CO₂",
      title: "每个养殖池都在计量它的吸收量",
      sub: "微藻在生长过程中自然捕获 CO₂。Dekrbat Pure 用传感器测量这种吸收，并通过脱碳预言机验证，实时生成碳积分。",
    },
    oracle: {
      overline: "预言机",
      title: "从传感器信号到碳积分",
      desc: "Dekrbat Pure 的测量架构将生物遥测转化为可验证的记录，无需依赖外部声明。",
      flow: ["微藻养殖池", "CO₂ 传感器", "脱碳预言机", "碳积分"],
      flowDescs: [
        "生长过程中的 CO₂ 自然吸收",
        "溶解 CO₂ 连续读数",
        "实时遥测验证",
        "按池和批次可追溯的记录",
      ],
    },
    telemetry: { title: "实时遥测", note: "数据流概念模拟" },
    reel: {
      overline: "碳的故事",
      title: "从养殖池到碳积分，动态呈现",
      slides: [
        { k: "01 · 养殖池", title: "活体培养", desc: "微藻池在为孵化场生产活体饵料的同时自然捕获 CO₂。" },
        { k: "02 · 传感器", title: "持续测量", desc: "溶解 CO₂ 和水质探头实时记录每个养殖池。" },
        { k: "03 · 预言机", title: "验证", desc: "脱碳预言机将遥测验证为可信记录。" },
        { k: "04 · 积分", title: "碳积分", desc: "每次验证都会发放可按池和批次追溯的碳积分。" },
      ],
    },
    chain: {
      overline: "价值链",
      title: "四个维度的影响",
      items: [
        { title: "环境", desc: "由传感器测量、预言机验证的自然 CO₂ 提取，逐批次进行。" },
        { title: "社会", desc: "为手工生产者和本地合作社提供长期可持续就业。" },
        { title: "经济", desc: "通过减少对进口饲料的依赖，增强孵化场的韧性。" },
        { title: "供应安全", desc: "以微藻养殖池为中心的新本地价值链。" },
      ],
    },
  },
  contact: {
    hero: {
      overline: "联系我们",
      title: "谈谈您的项目",
      sub: "写信给我们，Dekrbat Pure 团队将尽快回复。您也可以查看系统中保存的申请。",
    },
    form: {
      name: "姓名", email: "电子邮箱", subject: "主题", message: "留言",
      submit: "发送消息", sending: "发送中…",
      success: "消息已发送并保存。", error: "发送失败，请重试。",
    },
    drawer: {
      btn: "查看已保存的申请", title: "已保存的申请", empty: "暂无已保存的申请。",
      licenseTag: "许可", contactTag: "联系", close: "关闭", loading: "加载中…",
    },
  },
  intro: {
    dossier: "档案 · 全球", skip: "点击跳过",
    soundOn: "声音已开启——点击静音", soundOff: "已静音",
  },
  story: {
    overline: "故事",
    title: "从水中诞生的团结经济",
    scenes: [
      { k: "场景 01", title: "流失的价值", desc: "多年来，孵化场饲料依赖进口：每次采购都让资源流出本地区。" },
      { k: "场景 02", title: "生产者培育", desc: "手工生产者建起微藻池：水、阳光和 CO₂ 变成活体饵料。" },
      { k: "场景 03", title: "合作社连接", desc: "收获物直达本地区的孵化场。无中间商、无进口：短链条。" },
      { k: "场景 04", title: "价值留存", desc: "本地可持续就业、合作社收入和传感器验证的碳积分：经济在本地增长。" },
    ],
  },
  pseq2: {
    overline: "安装前可视化",
    title: "PSEQ2 —— 第二代固碳点",
    sub: "在安装微藻池之前，可视化地球任何地点的脱碳潜力：真实本地气候驱动模拟，每个结果都呈现在全息立方体中。",
    config: {
      title: "配置您的项目",
      bassins: "养殖池数量",
      bassinsFree: "或直接输入确切数量",
      surfaceFixed: "每个养殖池面积：100 平方米 — 分为 4 个 25 平方米的独立单元，以限制交叉污染风险",
      totalSurface: "总面积",
      sun: "场地遮阴情况",
      sunFull: "开阔", sunMid: "混合", sunLow: "遮阴",
      searchPlaceholder: "搜索城市或地点…",
      share: "分享模拟",
      shareCopied: "链接已复制",
    },
    location: {
      title: "项目位置",
      hint: "点击地图或搜索地点",
      loading: "正在加载当地气候…",
      error: "该点暂无气候数据",
      none: "在地图上选择一个点",
      satellite: "卫星图",
      mapLabel: "地图",
      locate: "我的位置",
    },
    tour: {
      replay: "教程",
      next: "下一步",
      skip: "跳过",
      done: "完成",
      steps: [
        { t: "欢迎使用 PSEQ2 模拟器", b: "一分钟估算你的本地活饵产量。开始吧！" },
        { t: "池塘数量", b: "拖动滑块：每个池塘是独立的 100 平方米单元，可防止交叉污染。" },
        { t: "光照条件", b: "露天、混合或遮阴：光照驱动微藻生长。" },
        { t: "项目位置", b: "点击地图或使用「我的位置」：模拟器加载当地真实天气。" },
        { t: "全息立方体", b: "3D 展示你的结果：PSEQ2 积分、捕获的 CO₂、本地饲料和就业。用手指旋转它。" },
        { t: "PDF 报告", b: "导出完整的场景报告，随时与合作社分享。" },
        { t: "分享模拟", b: "一键复制带卫星预览卡片的链接，用于 WhatsApp 和社交网络。" },
        { t: "完成了！", b: "随时点击教程按钮重新观看。" },
      ],
    },
    weather: { temp: "温度", humidity: "湿度", pressure: "气压", sunshine: "每日日照", hours: "小时" },
    rating: {
      title: "安装评估结论",
      basis: "基于真实本地气候计算：温度、日照、湿度和气压",
      levels: ["不推荐", "一般", "合适", "良好", "极佳"],
    },
    cubes: {
      pseq2: { label: "潜在 PSEQ2", unit: "分 / 年" },
      co2: { label: "固存 CO₂", unit: "吨 / 年" },
      feed: { label: "本地活体饵料", unit: "指数" },
      jobs: { label: "本地就业", unit: "岗位" },
    },
    preview: {
      title: "报告预览",
      config: "配置",
      weather: "当地气候",
      capacity: "产能摘要",
      contaminationTitle: "污染隔离",
      contaminationText: "每个 100 平方米的养殖池分为 4 个 25 平方米的独立单元：一旦出现污染源，仅隔离并检疫该单元——其余生产照常进行。",
    },
    history: {
      title: "情景历史",
      save: "保存情景",
      saved: "情景已保存",
      error: "无法保存情景",
      empty: "暂无已保存的情景：配置并保存您的第一次模拟。",
      exportPdf: "导出 PDF",
      publish: "公开",
      unpublish: "取消公开",
      sharedTag: "公开",
      tabAll: "全部",
      tabPublic: "公开",
      date: "日期",
    },
    disclaimer: "概念预览模型：基于真实本地气候的模拟值，不构成测量结果或性能承诺。",
    what: {
      overline: "定义",
      title: "什么是 PSEQ2？",
      desc: "PSEQ2——第二代固碳点——是 Dekrbat Pure 脱碳预言机在传感器遥测验证微藻自然捕获 CO₂ 时发放的单位。",
      cards: [
        { title: "测量", desc: "溶解 CO₂ 和水质探头在每个养殖池持续运行。" },
        { title: "验证", desc: "预言机实时核验遥测，逐池逐批。" },
        { title: "发放", desc: "每次验证生成可追溯的 PSEQ2，显示在您的全息立方体中。" },
      ],
    },
    cta: {
      title: "从模拟走向真实养殖池",
      desc: "申请许可，把这些全息立方体变成真实的遥测数据。",
      btn: "申请许可",
    },
    teaser: {
      overline: "全新",
      title: "安装前先可视化",
      desc: "PSEQ2 模拟器以真实本地气候驱动，将您未来养殖池的脱碳潜力投射到 3D 全息立方体中。",
      btn: "打开模拟器",
    },
  },
  footer: {
    tagline: "面向虾苗培育的本地微藻养殖系统，从萨尔瓦多走向世界。",
    nav: "导航",
    location: "萨尔瓦多，中美洲",
    rights: "版权所有。",
  },
};

const ja = {
  nav: {
    home: "ホーム", how: "仕組み", licensing: "ライセンス", impact: "インパクトと CO₂",
    contact: "お問い合わせ", cta: "ライセンス申請", pseq2: "PSEQ2", menu: "メニュー", close: "閉じる", logout: "ログアウト", oracle: "オラクル",
  },
  admin: {
    title: "管理パネル",
    licenses: "ライセンス申請",
    contacts: "お問い合わせメッセージ",
    empty: "まだ何もありません。",
    forbidden: "Dekrbat Pure チーム専用です。",
    statusT: "ステータス",
    pending: "保留中",
    accepted: "承認済み",
    rejected: "却下済み",
    accept: "承認",
    reject: "却下",
    loginFirst: "管理者アカウントでログインしてください。",
    filterAll: "すべて",
    reply: "返信",
    date: "日付",
  },
  oracle: {
    overline: "オフライン・オラクル",
    title: "Dekrbat オラクル — 予測とリアルタイム観測",
    sub: "アプリをインストールすると、各ゾーンの気象データがバックグラウンドで自動ダウンロードされます。グラフ・観測・PDFレポートはオフラインで動作します。",
    install: "アプリをインストール",
    installing: "ブラウザのメニューからインストール",
    online: "オンライン",
    offline: "オフライン — キャッシュデータ",
    syncing: "ゾーンを同期中",
    syncNow: "今すぐ同期",
    lastSync: "最終同期",
    never: "未同期",
    defaultZone: "養殖ゾーン",
    scenarioZone: "保存シナリオ",
    constatTitle: "ライブ観測",
    cachedAt: "データ取得",
    verdicts: { validated: "検証済み", partial: "部分的", rejected: "不合格" },
    criteria: { temp: "気温", sunshine: "日照", humidity: "湿度", pressure: "気圧", co2: "CO₂" },
    predTitle: "7日間予測",
    weeklyPts: "週間推定 PSEQ2 / 池",
    chartTemp: "最高気温",
    chartSun: "日照",
    reportBtn: "ゾーンPDFレポート",
    noData: "このゾーンのデータがまだありません — オンラインで同期してください。",
    customZone: "マイゾーン",
    addZoneTitle: "ゾーンを追加",
    addZoneHint: "地図をクリックしてピンを置き、ゾーンに名前を付けて保存。",
    zoneNamePh: "ゾーン名",
    saveZone: "保存",
    loginToAdd: "ログインすると自分のゾーンを保存し、センサーを接続してメール通知を受け取れます。",
    zoneSaved: "ゾーンを保存しました",
    zoneDeleted: "ゾーンを削除しました",
    saveFailed: "保存に失敗しました",
    deleteZone: "削除",
    alertsOn: "メール通知オン",
    alertsOff: "メール通知オフ",
    sensorConnect: "センサーを接続",
    sensorKeyOnce: "APIキー — 今すぐコピーしてください。再表示されません。",
    sensorLive: "実センサー",
    sensorOffline: "センサーオフライン",
    sensorCurl: "ゲートウェイからの送信例",
    thresholdsTitle: "カスタムしきい値",
    idealRange: "理想範囲",
    sunMin: "最小 (時間)",
    thresholdsSaved: "しきい値を保存しました",
    sensorHistory: "センサー履歴",
    noSensorData: "センサーデータがまだありません。",
    fieldMode: "フィールドモード",
    freshToday: "今日のデータ",
    freshCache: "キャッシュ",
    tour: {
      replay: "チュートリアル",
      next: "次へ",
      skip: "スキップ",
      done: "完了",
      steps: [
        { t: "Oracle へようこそ", b: "60秒で池のモニタリングをマスター。始めましょう！" },
        { t: "接続ステータス", b: "緑 = オンライン、オレンジ = キャッシュでオフライン。ネットがなくても動きます。" },
        { t: "同期", b: "ワンクリックで全ゾーンの7日間の天気をダウンロード。" },
        { t: "フィールドモード", b: "大きなボタンと高コントラスト：池のそばの直射日光でも読みやすい。" },
        { t: "自分のゾーン", b: "地図をクリックして名前を付ける：他のゾーンと同じように監視されます（要ログイン）。" },
        { t: "一目でわかる判定", b: "有効・一部・却下：今日の天気判定。センサー接続時は実データを使用。" },
        { t: "アプリをインストール", b: "Oracle をスマホに追加：オフラインでもアプリのように開けます。" },
        { t: "完了！", b: "上部のチュートリアルボタンでいつでも再生できます。" },
      ],
    },
  },
  landing: {
    overline: "機密解除ファイル",
    title: "あなたの地域の稚エビ用・地産の生餌。",
    sub: "手工業の生産者と稚エビ孵化場をつなぐ完全な微細藻類生産システム：短いサプライチェーン、輸入依存ゼロ、地域に残る収入。",
    points: ["手工業による生きた微細藻類の生産", "生産者から孵化場への短いチェーン", "地域に残る収入"],
    visitor: "ゲストとして入る",
    google: "Google で続行",
    divider: "またはメールで",
    name: "名前",
    email: "メール",
    password: "パスワード",
    loginBtn: "ログイン",
    signupBtn: "アカウント作成",
    toSignup: "アカウント未作成？作成する",
    toLogin: "すでにアカウントをお持ちですか？ログイン",
    err: "認証情報が無効か、メールが登録済みです",
  },
  hero: {
    overline: "エルサルバドル発 · 世界へ",
    lines: ["地産の生き餌", "稚エビのために", "あなたの地域から。"],
    sub: "Dekrbat Pure は完全な微細藻類生産システムをライセンス供与し、手工業生産者とエビ幼生孵化場を直接つなぎます。短いサプライチェーンが輸入飼料への依存を減らし、CO₂ をセンサー検証済みのカーボンポイントに変えます。",
    ctaPrimary: "ライセンス申請",
    ctaSecondary: "仕組みを見る",
    imageCaption: "微細藻類の養殖池",
    telemetryLabel: "脱炭素オラクル",
    telemetryLive: "ライブ信号",
    telemetryNote: "概念シミュレーション配信",
    telemetryLines: [
      "センサー A-03 · 溶存 CO₂ · 読取り検証済み",
      "オラクル · 自然吸収を検証",
      "カーボンポイント発行 · バッチ #0182",
      "センサー B-11 · 水質 · パラメータ安定",
      "オラクル · 池のテレメトリー同期完了",
      "カーボンポイント発行 · バッチ #0183",
    ],
  },
  valprop: {
    overline: "提案",
    title: "短いチェーンが輸入チェーンに取って代わる",
    imported: {
      title: "輸入飼料",
      points: [
        "孵化場まで数千キロを輸送",
        "為替や国際物流に左右されるコスト",
        "生物由来の追跡可能性が限定的",
        "経済価値が地域から流出",
      ],
    },
    local: {
      title: "Dekrbat Pure ローカルネットワーク",
      points: [
        "微細藻類は地域内の池で培養",
        "手工業生産者から孵化場へ直接配送",
        "すべての池にセンサーテレメトリー",
        "持続可能な雇用と価値が地域に残る",
      ],
    },
  },
  bento: {
    overline: "システム",
    title: "4つの要素、1つの生態系",
    items: {
      ponds: { title: "養殖池", desc: "沿岸・農村の条件に合わせた微細藻類生産インフラ。" },
      coops: { title: "協同組合ネットワーク", desc: "組織された手工業生産者が地域の幼生ラボへ直接供給。" },
      sensors: { title: "インラインセンサー", desc: "すべての養殖池で水質と溶存 CO₂ を常時監視。" },
      oracle: { title: "カーボンオラクル", desc: "検証済みテレメトリーがリアルタイムのカーボンポイントに。バッチ単位で追跡可能。" },
    },
  },
  marquee: [
    "食料主権", "輸入依存ゼロ", "センサー追跡", "持続可能な地域雇用", "リアルタイムカーボンポイント", "短いサプライチェーン",
  ],
  calc: {
    overline: "概念モデル",
    title: "養殖池ネットワークの規模を試算",
    desc: "システムのテレメトリーが養殖面積とともにどう拡大するかを確認。",
    sliderLabel: "養殖池のヘクタール数",
    unit: "ha",
    outputs: { volume: "相対生産指数", datapoints: "1日のセンサー読取数", points: "1日のカーボンポイント発行数" },
    disclaimer: "シミュレーション値は参考用です。実際の性能データではありません。",
  },
    xr: {
      overline: "空間モード",
      title: "あなたの養殖場がホログラムに",
      sub: "XREALグラス、Beam Pro、または普通の画面で：PSEQ2シミュレーターが立体3D模型に——衛星地球、立体的な池、リアルタイム気象。",
    },
  ctaSection: {
    title: "エビの未来を育てる準備はできましたか？",
    desc: "幼生養殖のための初のライセンス微細藻類ネットワークに参加。",
    btn: "ライセンス申請",
  },
  how: {
    hero: {
      overline: "仕組み",
      title: "池から幼生へ、仲介者なし",
      sub: "水・光・CO₂ を地域の生き餌に変える4ステップの生態系。各段階で計測。",
    },
    steps: [
      { k: "ステップ 01", title: "建設と接種", desc: "各ライセンスサイトが養殖池を設置し、スターター株と Dekrbat Pure 生産プロトコルを受け取ります。" },
      { k: "ステップ 02", title: "センサー監視下の成長", desc: "光学プローブと溶存 CO₂ センサーが水質と生物活性をリアルタイムで記録。池ごとに。" },
      { k: "ステップ 03", title: "地域直通配送", desc: "収穫物は手工業生産者から同地域の孵化場へ。輸入なしの短いチェーン。" },
      { k: "ステップ 04", title: "オラクル検証", desc: "脱炭素オラクルがセンサー測定の CO₂ 自然吸収を検証し、追跡可能なカーボンポイントを発行。" },
    ],
    sensor: {
      overline: "テクノロジー",
      title: "眠らないテレメトリー",
      desc: "すべてのライセンス池にセンサーキットを搭載し、脱炭素オラクルへ継続的に読取りを送信。",
      points: ["光学式水質プローブ", "溶存 CO₂ センサー", "リアルタイムデータ送信", "池・バッチ単位の追跡"],
    },
    galleryCaptions: ["エビ幼生の検査", "ラボでの培養サンプル"],
  },
  licensing: {
    hero: {
      overline: "ライセンス",
      title: "あらゆる生産規模に対応するライセンス",
      sub: "Dekrbat Pure は世界中のあらゆる地域の協同組合や個別サイトに、完全な微細藻類生産システムをライセンス供与します。",
    },
    coop: {
      badge: "協同組合",
      title: "協同組合ライセンス",
      desc: "複数の養殖場や幼生ラボを運営する協同組合・生産者団体向けの地域モデル。",
      features: [
        "1つのライセンスで複数養殖場をカバー",
        "池ごとに割り当てるセンサーキット",
        "生産プロトコルとチーム研修",
        "組合のオラクルテレメトリーパネルへのアクセス",
        "地域の孵化場との接続",
      ],
    },
    site: {
      badge: "個別サイト",
      title: "サイトライセンス",
      desc: "単一施設向けのオーダーメイド展開：幼生ラボ、養殖場、パイロット池。",
      features: [
        "1施設専用のライセンス",
        "サイト規模に合わせたセンサーキット",
        "立ち上げ支援と初回接種",
        "サイト独自のテレメトリーとカーボンポイント",
        "協同組合モデルへの成長経路",
      ],
    },
    selectBtn: "このライセンスを申請",
    form: {
      title: "ライセンス申請",
      desc: "運営内容をお聞かせください。Dekrbat Pure チームが審査します。",
      name: "氏名", org: "協同組合または会社", email: "メール", phone: "電話",
      department: "国 / 地域", type: "ライセンスタイプ", typeCoop: "協同組合", typeSite: "サイト",
      ponds: "池の数またはヘクタール数", message: "メッセージ（任意）",
      submit: "申請を送信", sending: "送信中…",
      success: "申請を受け付けました。Dekrbat Pure チームがまもなく審査します。",
      error: "送信できませんでした。もう一度お試しください。",
      selectPlaceholder: "選択してください",
    },
  },
  impact: {
    hero: {
      overline: "インパクトと CO₂",
      title: "すべての池が吸収量を計測する",
      sub: "微細藻類は成長しながら自然に CO₂ を取り込みます。Dekrbat Pure はその吸収をセンサーで測定し、脱炭素オラクルで検証して、リアルタイムのカーボンポイントを生成します。",
    },
    oracle: {
      overline: "オラクル",
      title: "センサー信号からカーボンポイントへ",
      desc: "Dekrbat Pure の計測アーキテクチャは、生物テレメトリーを外部の主張に頼らない検証可能な記録へ変換します。",
      flow: ["微細藻類の池", "CO₂ センサー", "脱炭素オラクル", "カーボンポイント"],
      flowDescs: [
        "成長中の CO₂ 自然吸収",
        "溶存 CO₂ の連続読取り",
        "リアルタイムのテレメトリー検証",
        "池・バッチ単位で追跡可能な記録",
      ],
    },
    telemetry: { title: "ライブテレメトリー", note: "データフローの概念シミュレーション" },
    reel: {
      overline: "カーボンストーリー",
      title: "池からカーボンポイントへ、動く物語",
      slides: [
        { k: "01 · 池", title: "生きた培養", desc: "微細藻類の池は孵化場向けの生き餌を生産しながら自然に CO₂ を吸収。" },
        { k: "02 · センサー", title: "連続計測", desc: "溶存 CO₂ と水質プローブがすべての池をリアルタイムで記録。" },
        { k: "03 · オラクル", title: "検証", desc: "脱炭素オラクルがテレメトリーを検証し、記録へ変換。" },
        { k: "04 · ポイント", title: "カーボンポイント", desc: "検証ごとに池・バッチ単位で追跡可能なカーボンポイントを発行。" },
      ],
    },
    chain: {
      overline: "バリューチェーン",
      title: "4つの次元のインパクト",
      items: [
        { title: "環境", desc: "センサーで測定されオラクルに検証された自然な CO₂ 抽出。バッチごとに。" },
        { title: "社会", desc: "手工業生産者と地域協同組合への長期的で持続可能な雇用。" },
        { title: "経済", desc: "輸入飼料への依存を減らし、孵化場のレジリエンスを向上。" },
        { title: "供給の安全性", desc: "微細藻類養殖池を中心とした新しい地域バリューチェーン。" },
      ],
    },
  },
  contact: {
    hero: {
      overline: "お問い合わせ",
      title: "プロジェクトについて話しましょう",
      sub: "ご連絡いただければ Dekrbat Pure チームが回答します。システムに保存された申請の確認も可能です。",
    },
    form: {
      name: "氏名", email: "メール", subject: "件名", message: "メッセージ",
      submit: "メッセージを送信", sending: "送信中…",
      success: "メッセージを送信・保存しました。", error: "送信できませんでした。もう一度お試しください。",
    },
    drawer: {
      btn: "保存済み申請を見る", title: "保存済み申請", empty: "まだ保存された申請はありません。",
      licenseTag: "ライセンス", contactTag: "連絡", close: "閉じる", loading: "読み込み中…",
    },
  },
  intro: {
    dossier: "ドシエ · グローバル", skip: "クリックでスキップ",
    soundOn: "サウンドオン — クリックでミュート", soundOff: "ミュート中",
  },
  story: {
    overline: "ストーリー",
    title: "水から生まれる連帯経済",
    scenes: [
      { k: "シーン 01", title: "流出する価値", desc: "長年、幼生用飼料は輸入頼みでした。購入のたびに資源が地域から流出していました。" },
      { k: "シーン 02", title: "生産者が育てる", desc: "手工業生産者が微細藻類の池を立ち上げる。水・太陽・CO₂ が生き餌になる。" },
      { k: "シーン 03", title: "協同組合がつなぐ", desc: "収穫物は地域の孵化場へ直行。仲介なし、輸入なしの短いチェーン。" },
      { k: "シーン 04", title: "残る価値", desc: "持続可能な地域雇用、組合の収入、センサー検証済みカーボンポイント。経済は地元で成長する。" },
    ],
  },
  pseq2: {
    overline: "設置前ビジュアライゼーション",
    title: "PSEQ2 — 第二世代隔離ポイント",
    sub: "微細藻類の池を設置する前に、地球上のあらゆる地点の脱炭素ポテンシャルを可視化。実際の地域気象がシミュレーションを駆動し、すべての結果がホログラフィックキューブに表示されます。",
    config: {
      title: "プロジェクト設定",
      bassins: "池の数",
      bassinsFree: "または正確な数を入力",
      surfaceFixed: "池あたりの面積: 100 m² — 交差汚染を抑えるため 25 m² の独立ユニット 4 つに分割",
      totalSurface: "総面積",
      sun: "サイトの遮蔽",
      sunFull: "開放", sunMid: "混合", sunLow: "日陰",
      searchPlaceholder: "都市や場所を検索…",
      share: "シミュレーションを共有",
      shareCopied: "リンクをコピーしました",
    },
    location: {
      title: "プロジェクトの位置",
      hint: "地図をクリックするか場所を検索",
      loading: "地域の気象を読み込み中…",
      error: "この地点の気象データはありません",
      none: "地図上で地点を選択",
      satellite: "衛星写真",
      mapLabel: "地図",
      locate: "現在地",
    },
    tour: {
      replay: "チュートリアル",
      next: "次へ",
      skip: "スキップ",
      done: "完了",
      steps: [
        { t: "PSEQ2 シミュレーターへようこそ", b: "1分で地域の生き餌生産を試算。始めましょう！" },
        { t: "池の数", b: "スライダーをドラッグ：各池は100㎡の独立ユニットで交差汚染を防ぎます。" },
        { t: "日照条件", b: "露天・混合・日陰：光が微細藻類の成長を左右します。" },
        { t: "プロジェクトの場所", b: "地図をクリック、または「現在地」：実際の気象データを読み込みます。" },
        { t: "ホログラフィックキューブ", b: "結果を3Dで：PSEQ2ポイント、CO₂吸収量、地域飼料、雇用。指で回せます。" },
        { t: "PDFレポート", b: "シナリオの完全なレポートをエクスポート。協同組合とすぐ共有。" },
        { t: "シミュレーションを共有", b: "ワンクリックで衛星プレビューカード付きリンクをコピー。WhatsAppやSNSに。" },
        { t: "完了！", b: "チュートリアルボタンでいつでも再生できます。" },
      ],
    },
    weather: { temp: "気温", humidity: "湿度", pressure: "気圧", sunshine: "日照 / 日", hours: "時間" },
    rating: {
      title: "設置判定",
      basis: "実際の地域気象から算出：気温・日照・湿度・気圧",
      levels: ["非推奨", "可", "適", "良", "優"],
    },
    cubes: {
      pseq2: { label: "潜在 PSEQ2", unit: "pt / 年" },
      co2: { label: "隔離 CO₂", unit: "t / 年" },
      feed: { label: "地域生き餌", unit: "指数" },
      jobs: { label: "地域雇用", unit: "件" },
    },
    preview: {
      title: "レポートのプレビュー",
      config: "設定",
      weather: "地域の気象",
      capacity: "能力サマリー",
      contaminationTitle: "汚染の封じ込め",
      contaminationText: "100 m² の池は 25 m² の独立ユニット 4 つに分割されています。汚染が発生してもそのユニットだけを隔離・検疫し、残りの生産は継続します。",
    },
    history: {
      title: "シナリオ履歴",
      save: "シナリオを保存",
      saved: "シナリオを保存しました",
      error: "シナリオを保存できませんでした",
      empty: "保存されたシナリオはまだありません。設定して最初のシミュレーションを保存してください。",
      exportPdf: "PDF エクスポート",
      publish: "公開",
      unpublish: "非公開にする",
      sharedTag: "公開中",
      tabAll: "すべて",
      tabPublic: "公開",
      date: "日付",
    },
    disclaimer: "概念プレビューモデル：実際の地域気象に基づくシミュレーション値であり、測定値や性能の保証ではありません。",
    what: {
      overline: "定義",
      title: "PSEQ2 とは？",
      desc: "PSEQ2（第二世代隔離ポイント）は、センサーテレメトリーが微細藻類による CO₂ の自然吸収を検証したときに Dekrbat Pure の脱炭素オラクルが発行する単位です。",
      cards: [
        { title: "計測", desc: "溶存 CO₂ と水質プローブがすべての池で常時稼働。" },
        { title: "検証", desc: "オラクルが池ごと・バッチごとにリアルタイムでテレメトリーを検証。" },
        { title: "発行", desc: "検証ごとに追跡可能な PSEQ2 が生成され、ホログラフィックキューブに表示。" },
      ],
    },
    cta: {
      title: "シミュレーションから実際の池へ",
      desc: "ライセンスを申請して、これらのホログラフィックキューブを実際のテレメトリーに変えましょう。",
      btn: "ライセンス申請",
    },
    teaser: {
      overline: "新機能",
      title: "設置前に可視化",
      desc: "PSEQ2 シミュレーターは実際の地域気象を使い、将来の池の脱炭素ポテンシャルを 3D ホログラフィックキューブに投影します。",
      btn: "シミュレーターを開く",
    },
  },
  footer: {
    tagline: "エビ幼生養殖のためのローカル微細藻類養殖システム。エルサルバドルから世界へ。",
    nav: "ナビゲーション",
    location: "エルサルバドル、中央アメリカ",
    rights: "全著作権所有。",
  },
};

export const extraDictionaries = { ru, ar, zh, ja };
